import { Box } from '@mui/material';
import { FormCheckbox, LwFormMultiSelect } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { paymentStates } from 'hq/components/views/finance/payments/payments.types';
import { formatPaymentStatus } from 'shared/utils/formatting';
import { FilterStatusFormContext } from './filter-payment-status.types';

export const FilterPaymentStatus = () => {
  const { watch, control } = useFormContext<FilterStatusFormContext>();
  const { allowStatusFilter } = watch();
  const options = useMemo(
    () =>
      Object.values(paymentStates).map((key) => ({
        id: key,
        name: formatPaymentStatus(key),
      })),
    []
  );

  return (
    <Box>
      <FormCheckbox
        name="allowStatusFilter"
        label="Status"
        control={control}
        isHeaderCheckbox={true}
      />
      {allowStatusFilter ? (
        <Box paddingLeft="30px">
          <LwFormMultiSelect
            name="status"
            label="Status"
            data-testid="status-multiselect"
            control={control}
            options={options}
            getOptionLabel={(option) => option.name}
            getOptionKey={(option) => option.id}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        </Box>
      ) : null}
    </Box>
  );
};
